import { render, staticRenderFns } from "./MdfeDetails.vue?vue&type=template&id=41170578&scoped=true&"
import script from "./MdfeDetails.vue?vue&type=script&lang=js&"
export * from "./MdfeDetails.vue?vue&type=script&lang=js&"
import style0 from "./MdfeDetails.vue?vue&type=style&index=0&id=41170578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41170578",
  null
  
)

export default component.exports